<template>
    <div class="footBox">
        <div class="iconBox" @click="toTg()">
            <img src="../assets/Vector@2x.png" class="iconTg"/>
        </div>
        <div class="iconBox" @click="toX()">
            <img src="../assets/twitter-alt@2x.png" class="iconX"/>
        </div>

<!--        <div class="updateTime">数据更新时间：4月10日</div>-->
    </div>
  </template>

  <script>
  export default {
    name: 'foot',
    setup() {
    },
    methods: {
      toTg() {
        const tempWindows = window.open("_blank");
        tempWindows.location = "https://t.me/HyperInsight";
      },
      toX() {
        const tempWindows = window.open("_blank");
        tempWindows.location = "https://t.me/HyperInsight";
      }
    }
  }
  </script>

  <style lang="less" scoped>
  .footBox{
        width: 100%;
        height: 125px;
        background: #181717;
        //position: fixed;
        bottom: 0;
        left: 0;
        padding:40px 120px;
        z-index: 999;
        .iconBox {
            width: 40px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 10px;
            float: left;
            margin-right: 48px;
            padding-top: 10px;
            padding-bottom: 10px;
            padding-left: 10px;
            cursor: pointer;
            img {
                &.iconTg {
                    margin-left: 1px;
                    width: 18px;
                }
                &.iconX{
                    width: 20px;
                }
            }
        }
        .updateTime {
            width: 150px;
            padding-top: 10px;
            height: 20px;
            float: right;
            font-weight: 400;
            font-size: 14px;
            color: #6c7da4;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }
  }
  </style>
